const cs_msg = {
    title: "Kontrola rizik ve veřejných zakázkách",
    titleDetail: "Kontrola - {name}",
    button: {
        detail: "Detail",
        cancel: "Zrušit",
        order: "Mám zájem",
        close: "Zavřít"
    },
    buyer: "Zadavatel",
    supplier: "Dodavatelů | Dodavatel | Dodavatelé | Dodavatelů",
    organization_id: "IČO",
    period: "Období",
    rightClick: {
        copy: "Kopírovat adresu",
        tab: "Otevřít v novém panelu"
    },
    currency: {
        czk: "Kč",
        millions: "milionů | milion | miliony | milionů"
    },
    registr: "Registr smluv",
    risk: {
        level: {
            high: "vysoké",
            medium: "střední",
            low: "nízké",
            no: "nezjištěno"
        },
        levelFull: {
            high: "vysoké riziko",
            medium: "střední riziko",
            low: "nízké riziko",
            no: "riziko nezjištěno"
        }
    },
    ordering: {
        label: "Seřadit",
        options: {
            age: {
                asc: "Nejstarší",
                desc: "Nejnovější"
            },
            risk: {
                asc: "Nejméně rizikový",
                desc: "Nejrizikovější"
            },
            date: {
                asc: "Nejstarší",
                desc: "Nejnovější"
            },
            price: {
                asc: "Nejmenší",
                desc: "Největší"
            },
            alphabet: {
                asc: "Abecedně"
            },
            flags: {
                asc: "Od nejmenšího počtu rizik",
                desc: "Od největšího počtu rizik"
            }
        }
    },
    source: "Zdroj",
    url: "Odkaz",
    profile_url: "Profil",
    vestnik_url: "Věstník",
    intern_data_url: "Interní data zadavatele",
    flags: "Rizika",
    nav: {
        risks: "Rizika",
        tenders: "Zakázky",
        suppliers: "Dodavatelé",
        contracts: "Smlouvy",
        errors: "Chyby",
        support: "Podpora",
        network: "Mapa"
    },
    table: {
        empty: "Žádné záznamy k zobrazení",
        filter: {
            empty: "Žádné záznamy opovídající hledanému výrazu",
            placeholder: "Zadejte hledaný výraz",
            cancel: "Zrušit",
            label: "Hledat"
        },
        pagination: {
            label: "na stránku",
            total: "Žádné záznamy | Celkem {0} záznam | Celkem {0} záznamy | Celkem {0} záznamů"
        },
        sort: {
            asc: "Seřadit vzestupně",
            desc: "Seřadit sestupně",
            clear: "Zrušit řazení"
        }
    },
    manager: {
        title: "Přehled analýz",
        table: {
            head: {
                name: "jméno",
                created: "vytvořeno"
            }
        }
    },
    multiselect: {
        selectLabel: "Stiskněte enter pro výběr",
        selectedLabel: "Vybraný",
        deselectLabel: "Stiskněte enter pro odstranění",
        selectGroupLabel: "Stiskněte enter pro výběr skupiny",
        deselectGroupLabel: "Stiskněte enter pro odstranění skupiny",
        noOptions: "Žádnépoložky",
        noOptionsWithResult: "Žádné další položky",
        noResults: "Žádné vybrané položky"
    },
    datepicker: {
        labelPrevDecade: "Předchozí dekáda",
        labelPrevYear: "Předchozí rok",
        labelPrevMonth: "Předchozí měsíc",
        labelCurrentMonth: "Aktuální měsíc",
        labelNextMonth: "Další měsíc",
        labelNextYear: "Další rok",
        labelNextDecade: "Další dekáda",
        labelToday: "Dnes",
        labelSelected: "Vybraný datum",
        labelNoDateSelected: "Žádný datum",
        labelCalendar: "Kalendář",
        labelNav: "Navigace kalendáře",
        labelHelp: "Použijte šipky pro změnu data",
        labelTodayButton: "Dnes",
        labelResetButton: "Zrušit",
        labelCloseButton: "Zavřít"
    },
    overview: {
        indicator: {
            min: " %, podprůměrný výskyt",
            bellow50: " %, průměrný výskyt",
            above50: " %, nadprůměrný výskyt",
            max: " %, vysoce nadprůměrný výstkyt"
        },
        risk: {
            short: "Výše rizika: {0}",
            long: "Potenciál pro roční úsporu při omezení nadměrných rizik: {save} Kč",
            level: {
                high: "vysoké",
                medium: "střední",
                low: "nízké"
            }
        },
        supplier: {
            short: "{0} vysoce rizikových dodavatelů | {0} rizikový dodavatel | {0} rizikoví dodavatelé | {0} vysoce rizikových dodavatelů",
            long: "Ze všech {0} dodavatelů nacházíme významná rizika u {1}."
        },
        sum: {
            short: "{0} Kč",
            long: "Objem analyzovaných výdajů, tedy zejména zakázek a smluv."
        },
        flags: {
            title: "Zjištěná rizika",
            header: [
                "Riziko",
                "Počet případů",
                "Výše rizika",
                "Typ"
            ],
            other: "Online prezentace těchto rizik zdarma",
            shareOnSpendings: "Vyšší přesnost a dvojnásobek prověřených rizik ve Velké kontrole"
        },
        carousel: {
            title: "Ukázka rizik",
            expand: ". . . více",
            collapse: "zobrazit méně"
        },
        poster: {
            title: "Kontrola",
            description: [
                "{0} konkrétních rizik",
                "Detailní přehled všech dodavatelů",
                "Webová aplikace",
                "Pomoc při ověřování rizik"
            ]
        },
        suppliers: {
            title: "Seznam dodavatelů",
            table: {
                head: {
                    risk: "Riziko",
                    name: "Název",
                    priceFull: "Zaplaceno&nbsp;v&nbsp;Kč",
                    priceLite: "Zadáno&nbsp;v&nbsp;Kč",
                    department: "Nejčastější osoba / Oddělení"
                },
                search: {
                    placeholder: "Hledat"
                },
                filter: {
                    label: "Filtry",
                    flags: {
                        label: "Rizika",
                        all: "Vše",
                        write: "Vyberte rizika"
                    },
                    date: {
                        label: "Datum",
                        from: "Start",
                        to: "Konec"
                    },
                    submit: "Filtrovat"
                },
                treemap: {
                    hide: "Schovat graf",
                    show: "Ukázat graf",
                    title: "dodavatelů"
                },
                fields: {
                    label: "Parametry"
                },
                pagination: {
                    label: "Na stránku"
                }
            }
        },
        tenders: {
            title: "Seznam zakázek",
            table: {
                head: {
                    risk: "Riziko",
                    date: "Datum",
                    name: "Název",
                    supplier: "Dodavatel",
                    price: "Cena",
                    paid: "Zaplaceno"
                },
                search: {
                    placeholder: "Hledat"
                },
                filter: {
                    label: "Filtry",
                    flags: {
                        label: "Rizika",
                        all: "Vše"
                    },
                    date: {
                        label: "Datum"
                    }
                },
                treemap: {
                    hide: "Schovat graf",
                    show: "Ukázat graf",
                    title: "zakázek"
                },
                fields: {
                    label: "Parametry"
                }
            }
        },
        contracts: {
            title: "Seznam smluv",
            table: {
                head: {
                    risk: "Riziko",
                    date: "Datum",
                    name: "Název",
                    supplier: "Dodavatel",
                    price: "Cena",
                    paid: "Zaplaceno"
                },
                search: {
                    placeholder: "Hledat"
                },
                filter: {
                    label: "Filtry",
                    flags: {
                        label: "Rizika",
                        all: "Vše"
                    },
                    date: {
                        label: "Datum"
                    }
                },
                treemap: {
                    hide: "Schovat graf",
                    show: "Ukázat graf",
                    title: "smluv"
                },
                fields: {
                    label: "Parametry"
                }
            }
        },
        network: {
            title: "Mapa společnosti"
        }
    },
    supplierDetail: {
        nav: {
            overview: "Přehled",
            histogram: "Histogram cen",
            won: "Vyhrané zakázky",
            lost: "Neúspěšné účasti o zakázky",
            contracts: "Registr smluv",
            invoices: "Přehled faktur",
            flags: "Rizika",
            icontracts: "Interní evidence smluv",
            concurrency: "Statistika společných zakázek",
            nodata: "Nejsou informace",
            payments: "Platby",
            suppliersList: "Přehled dodavatelů"
        },
        flags: {
            header: {
                risk: "Riziko",
                group: "Typ rizika",
                name: "Název rizika"
            },
            nodata: "žádná rizika nenalezena",
            other: {
                group: "Specifická rizika",
                name: "{count} rizikových vztahů",
                desc: "Specifická rizika naleznete níže u jednotlivých smluv, zakázek, či konkurentů."
            }
        },
        overviewSummary: {
            vestnikBidSum: "Věstník (od {0} Kč)",
            profilBidSum: "Profil (od {0} Kč)",
            rsmluvBidSum: "Registr smluv (od {0} Kč)",
            esmluvBidSum: "Evidence smluv (od {0} Kč)",
            accountingPayments: "Zaplaceno",
            bidsCountAvg: "Průměrný počet nabídek",
            wonRatio: "Podíl vyhraných zakázek",
            fromTo: "Od - do"
        },
        concurrency: {
            histogram: {
                title: "Počty konkurenčních nabídek",
                description: "Počty konkurujících nabídek v zakázkách, o které se dodavatel ucházel.",
                label: {
                    bids_0: "0",
                    bids_1: "1",
                    bids_2: "2",
                    bids_3: "3",
                    bids_4: "4",
                    bids_5: "5",
                    bids_6: "6+"
                }
            },
            table: {
                head: {
                    others: "Někdo jiný",
                    company: "Dodavatel",
                    concurrents: "Konkurent",
                    tenderCount: "Společně soutěžili"
                },
                text: {
                    otherWins: "Někdo jiný"
                },
                data: {
                    total: "o {count} zakázek | o {count} zakázku | o {count} zakázky | o {count} zakázek",
                    tenders: "vyhrál {count} zakázek | vyhrál {count} zakázku | vyhrál {count} zakázky | vyhrál {count} zakázek",
                    more: "+ {count} dalších | + {count} další | + {count} další | + {count} dalších"
                }
            },
            noflags: "žádná rizika konkurenta nenalezena"
        },
        tenders: {
            table: {
                head: {
                    risk: "Riziko",
                    date: "Datum",
                    name: "Název",
                    price: "Cena",
                    flagsCount: "Počet rizik",
                    winner: "Vítěz"
                }
            }
        },
        contracts: {
            histogram: {
                title: "Velikosti uzavřených smluv",
                description: "Graf zobrazuje počet uzavřených smluv v závislosti na jejich ceně",
                label: {
                    price_0: "n/a",
                    price_1: "<100K",
                    price_2: "200K",
                    price_3: "500K",
                    price_4: "1M",
                    price_5: "2M",
                    price_6: "6M",
                    price_7: ">6M"
                }
            },
            table: {
                head: {
                    date: "Datum",
                    name: "Název",
                    price: "Částka",
                    url: "Odkaz",
                    person: "Osoba",
                    sid: "Číslo smlouvy"
                }
            },
            nodata: "žádné smlouvy nenalezeny",
            novalue: "---"
        },
        icontracts: {
            histogram: {
                title: "Velikosti uzavřených smluv",
                description: "Graf zobrazuje počet uzavřených smluv v závislosti na jejich ceně"
            }
        },
        nodata: {
            description: "Sekce <strong>{sections}</strong> není zobrazena, protože pro dodavatele neobsahuje žádné informace."
        },
        payments: {
            table: {
                head: {
                    date: "Datum",
                    price: "Částka",
                    tender: "Zakázka",
                    details: "",
                    accounting_number: "Účetní číslo",
                    accounting_name: "Účetní",
                    budget_unit_number: "Rozpočet - číslo jednotky",
                    budget_unit_name: "Rozpočet - jméno jednotky",
                    budget_paragraph_number: "Rozpočet - číslo paragrafu",
                    budget_paragraph_name: "Rozpočet - paragraf",
                    department: "Oddělení",
                    person: "Osoba",
                    note: "Poznámka",
                    note2: "Poznámka"
                }
            },
            nodata: "žádné platby nejsou evidovány"
        }
    },
    tenderDetail: {
        overviewSummary: {
            supplier: "Dodavatel",
            signatureDate: "Podpis smlouvy",
            price: "Vysoutěžená cena | Vysoutěžená cena | Vysoutěžená cena (součet {count} částí) | Vysoutěžená cena (součet {count} částí)",
            paymentsSum: "Zaplacená cena",
            awardUrl: "Zdroj"
        },
        nav: {
            overview: "Přehled",
            concurrency: " Ostatní uchazeči",
            risks: "Rizika",
            flags: "Rizika",
            tendersList: "Přehled zakázek",
            payments: "Platby",
            nodata: "Nejsou informace"
        },
        payments: {
            table: {
                head: {
                    date: "Datum",
                    price: "Částka",
                    details: "",
                    accounting_number: "Účetní číslo",
                    accounting_name: "Účetní",
                    budget_unit_number: "Rozpočet - číslo jednotky",
                    budget_unit_name: "Rozpočet - jméno jednotky",
                    budget_paragraph_number: "Rozpočet - číslo paragrafu",
                    budget_paragraph_name: "Rozpočet - paragraf",
                    department: "Oddělení",
                    person: "Osoba",
                    note: "Poznámka",
                    note2: "Poznámka"
                }
            },
            nodata: "žádné platby nejsou evidovány"
        },
        concurrency: {
            table: {
                head: {
                    name: "Název",
                    flags: "Rizika",
                    price: "Nabídková cena"
                }
            },
            noflags: "žádná rizika konkurenta nenalezena",
            nodata: "žádní konkurenti nejsou evidováni"
        },
        nodata: {
            description: "Sekce <strong>{sections}</strong> není zobrazena, protože pro zakázku neobsahuje žádné informace."
        },
        flags: {
            header: {
                risk: "Riziko",
                group: "Typ rizika",
                name: "Název rizika"
            },
            nodata: "žádná rizika nenalezena",
            other: {
                group: "Specifická rizika",
                name: "{count} rizikových vztahů",
                desc: "Specifická rizika naleznete níže u jednotlivých smluv, zakázek, či konkurentů."
            }
        }
    },
    contractDetail: {
        overviewSummary: {
            supplier: "Dodavatel",
            signatureDate: "Podpis smlouvy",
            price: "Smluvní cena",
            paymentsSum: "Zaplacená cena",
            sourceUrl: "Zdroj"
        },
        nav: {
            overview: "Přehled",
            risks: "Rizika",
            flags: "Rizika",
            contractsList: "Přehled smluv",
            payments: "Platby",
            nodata: "Nejsou informace"
        },
        payments: {
            table: {
                head: {
                    date: "Datum",
                    price: "Částka",
                    details: "",
                    accounting_number: "Účetní číslo",
                    accounting_name: "Účetní",
                    budget_unit_number: "Rozpočet - číslo jednotky",
                    budget_unit_name: "Rozpočet - jméno jednotky",
                    budget_paragraph_number: "Rozpočet - číslo paragrafu",
                    budget_paragraph_name: "Rozpočet - paragraf",
                    department: "Oddělení",
                    person: "Osoba",
                    note: "Poznámka",
                    note2: "Poznámka"
                }
            },
            nodata: "žádné platby nejsou evidovány"
        },
        nodata: {
            description: "Sekce <strong>{sections}</strong> není zobrazena, protože pro slouvu neobsahuje žádné informace."
        },
        flags: {
            header: {
                risk: "Riziko",
                group: "Typ rizika",
                name: "Název rizika"
            },
            nodata: "žádná rizika nenalezena",
            other: {
                group: "Specifická rizika",
                name: "{count} rizikových vztahů",
                desc: "Specifická rizika naleznete níže u jednotlivých smluv, zakázek, či konkurentů."
            }
        }
    },
    premium: "Velká kontrola",
    navigationContextMenu: {
        openNewTab: "Otevřít v novém panelu",
        openNewWindow: "Otevřít v novém okně",
        copyToClipboard: "Kopírovat adresu"
    },
    footer: {
        text: [
            "Datlab Kontrola je nástroj pro předcházení rizik ve veřejných zakázkách. Každodenní příručka pro manažery, cenný podklad pro audit.",
            "Datlab je česká firma specializující se na získávání, zpracování a analýzu dat. Primárně se soustředíme na ekonomická data a sektor veřejných zakázek. Díky unikátní symbióze technologického a ekonomického know - how mají naše výstupy vysokou kvalitu a spolehlivost."
        ],
        contact: {
            label: "KONTAKT",
            addressHtml: "Datlab s.r.o.<br />Charlese de Gaulla 629/5<br />160 00 Praha 6<br />Česká republika<br />",
            vatId: "IČ: 24213101 DIČ: CZ24213101"
        },
        products: {
            label: "PRODUKTY",
            tendry: "Datlab Tendry",
            check: "Datlab Kontrola",
            zindex: "Zindex"
        },
        others: {
            label: "OSTATNÍ",
            facebook: "Facebook",
            datlab: "Datlab",
            institut: "Datlab Institut"
        },
        copyright: "Copyright 2021 Datlab s.r.o. | Spisová značka: C 189197 vedená u Městského soudu v Praze | b.ú. 364357596/0300 Československá obchodní banka, a. s. (IBAN CZ8103000000000364357596)"
    }
}


export default cs_msg;